import classes from '../../Classes';
var corporate = function corporate() {
  return {
    getGridAlignment: function getGridAlignment() {
      return classes.GRID_ALIGNMENT.START;
    },
    getAlignment: function getAlignment() {
      return classes.ALIGNMENT.LEFT;
    },
    getVerticalAlignment: function getVerticalAlignment() {
      return classes.VERTICAL_ALIGNMENT.SPACE_BETWEEN;
    }
  };
};
export default corporate;